import React, { useEffect } from 'react';
import System from 'src/helper/system';
import creditline from "src/assets/images/credit-line-icon.svg";
import HCLDX from "@system/config/hcldx";
import Profile from '@system/config/profile';
import Constants from 'src/helper/Constants';
import { profileStore } from 'src/hooks/profile';
import Helper from 'src/helper/Helper';
import { useAxiosIndicatorCheck } from "../../store/hook/useAxiosIndicatorCheck";
import liveAuth from 'src/helper/liveAuth';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';

const ProfileInformation = () => {
    const { siteUser: { WEB, CORE } } = Constants
    const { avUserInfoData: { currentUser, accountNumber, accountName }, storageName: { ACCOUNT_LINK_SUCCESS_MESSAGE } } = System
    const isWebAndCoreUSer = currentUser === WEB || currentUser === CORE

    const [{ profile_user_information }, { get_profile_account_information }] = profileStore();
    const [__check] = useAxiosIndicatorCheck();
    const isInternalUser = System.validateDomain(liveAuth.getAvUserInfo()?.email)
    const [{ }, { clear_all_system_alert }, { }] = useDOMAttachToSystemStore();
    const OpenContactInfoPopup = (name) => {
        clear_all_system_alert()
        sessionStorage.removeItem(ACCOUNT_LINK_SUCCESS_MESSAGE)
        System.popup('ContactInformationPopup', name);
    }

    const existingAccountRedirection = () => {
        window.location.href = Profile.getLinkToExistingAccountURL();
    }

    useEffect(() => {
        async function fetchHere() {
            await get_profile_account_information();
        }
        if (Object.keys(profile_user_information).length <= 0) {
            fetchHere()
        }
    }, [profile_user_information])


    return (
        <>{__check("PROFILE_ACCOUNT_INFORMATION").status ? __check('PROFILE_ACCOUNT_INFORMATION').render :
            <div>
                <div className=''>
                    <div className='profile-info-container'>
                        <div className='profile-edit-profile'>
                            <div className='row'>
                                <div className='col-md-12 mb-3'>
                                    {currentUser === WEB &&
                                        <a href={void (0)} onClick={() => OpenContactInfoPopup("contactInformation")}><i className="fa fa-pencil" /> Edit Profile</a>}
                                </div>
                                <div className='col-md-6'>
                                    <div className='edit-profile-list'>
                                        <ul className='m-0 p-0'>
                                            <li>
                                                <span>Name:</span>
                                                <div>{profile_user_information?.firstName}&nbsp;{profile_user_information?.lastName}</div>
                                            </li>
                                            <li>
                                                <span>Company:</span>
                                                <div>{Helper.valueIsNotNull(profile_user_information?.company) ? profile_user_information?.company : ""}</div>
                                            </li>
                                            <li>
                                                <span>Job Title:</span>
                                                <div>{profile_user_information?.jobTital}</div>
                                            </li>
                                            <li>
                                                <span>Job Function:</span>
                                                <div>{profile_user_information?.jobFunction}</div>
                                            </li>
                                            <li>
                                                <span>Phone:</span>
                                                <div>{profile_user_information?.mobileNumber}</div>
                                            </li>
                                            <li>
                                                <span>Email:</span>
                                                <div>{profile_user_information?.emailAddress}</div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    {isWebAndCoreUSer && <div className='mb-3'><span className='font-16 font-arial d-block '><b> Account </b></span>
                                        {currentUser === CORE && <div>{accountNumber} - {accountName}</div>}
                                        <a href={void (0)} className='font-13 font-arial' onClick={existingAccountRedirection}>Request to Join Existing Account</a></div>}
                                    {!isInternalUser && <div><span className='font-16 font-arial d-block '><b> Password </b></span><a href={HCLDX.baseURL() + '/authenticate/change-password'}>Change Password</a></div>}
                                </div>
                                {currentUser === CORE && <div className='col-md-12 mt-4'>
                                    <div className='font-16 font-arial'><strong>TAX EXEMPT:</strong> </div>
                                    <p className='font-13 font-arial'>Your account is setup to receive tax exemption.</p>
                                </div>}
                            </div>
                        </div>
                        <div className='profile-need-info'>
                            <div>
                                <div className='mb-4'><span className='font-16 font-arial d-block'><b> Need More Information </b></span>Visit our <a href={System.getHelpURL()}>help page.</a></div>
                            </div>
                            <div className='credit-line'>
                                <div className='credit-line-blackbox'>
                                    <img src={creditline} className="" />
                                    Credit Line
                                </div><div className='d-flex align-items-center apply-credit-line'>
                                    <div><b className='d-block'>Apply For Credit Line </b> Use this payment option to ensure that your account is set up to have a Credit Line through Avnet. </div>
                                    <div className='ms-3'> <button type="button" className="bs5 btn btn-secondary btn-sm"><a className='text-darkgreen' href='https://www.avnet.com/wcsstore/AvnetSAS/StaticContent/AvnetCreditApplication.pdf' target="_blank">Apply</a> </button></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }
        </>
    )
}
export default ProfileInformation;